import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d14edb3"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = ["id", "src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.visible,
    width: "970px",
    footer: null,
    title: _ctx.videoTitle,
    destroyOnClose: "",
    onCancel: _ctx.handleCancel
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_a_tabs, {
          class: "tabs",
          type: "card",
          onChange: _ctx.changeVideo,
          tabPosition: _ctx.tabPosition
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.videos, (video, index) => {
              return (_openBlock(), _createBlock(_component_a_tab_pane, {
                key: index,
                tab: _ctx.tabName(index)
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    id: `content${index + 1}`,
                    class: "content"
                  }, [
                    _createElementVNode("video", {
                      id: `video${index + 1}`,
                      class: "video",
                      src: _ctx.header + video,
                      autoplay: "",
                      "webkit-playsinline": "true",
                      playsinline: "true",
                      controls: ""
                    }, null, 8, _hoisted_2)
                  ], 8, _hoisted_1)
                ]),
                _: 2
              }, 1032, ["tab"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["onChange", "tabPosition"])
      ])
    ]),
    _: 1
  }, 8, ["visible", "title", "onCancel"]))
}